import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

// Reuses the same signal the app-wide reconnect banner uses
// (GET /api/caddy/sheet-status) so Settings + nav flag the exact same
// "Google access has lapsed / Sheets permission missing" cases. No new signal.
export function useSheetReconnect() {
  const [state, setState] = useState({ needsReconnect: false, reconnectPath: null });
  useEffect(() => {
    let live = true;
    (async () => {
      try {
        const res = await fetch(`${API}/api/caddy/sheet-status`, { credentials: "include" });
        if (!res.ok) return;
        const b = await res.json();
        if (live) setState({ needsReconnect: !!b.needs_reconnect, reconnectPath: b.reconnect_path || null });
      } catch { /* offline, stay silent */ }
    })();
    return () => { live = false; };
  }, []);
  return state;
}
